module.exports = __webpack_public_path__ + "static/img/case_03.71d98bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case_03.jpg
// module id = +map
// module chunks = 0